import * as types from '../actions/messages/types';


const INITIAL_STATE = {
  messageThread: {},
  messageThreadHeaders: [],
  recipients: [],
};

export default function messagesReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.FETCH_MESSAGE_THREAD_HEADERS:

      return { ...state, messageThreadHeaders: action.payload };

    case types.GET_MESSAGE:

      return { ...state, messageThread: action.payload };

    case types.GET_POSSIBLE_RECIPIENTS:

      return { ...state, recipients: action.payload };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/messagesReducer.js